var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 188,
    viewBox: "0 0 199 188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 188
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_8",
    "data-name": "Artboard \\u2013 8",
    clipPath: "url(#clip-Artboard_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M167.794,285.522h67.188L215.712,236.7,161.959,196.62l8.368-37.478s-21.559-5.644-29.14-2.412-18.831,7.758-20.373,14.7,2.943,18.113,2.943,18.113,3.862,11.207,4.373,12.931,2.963,11.011,2.963,11.011.163.513-.572,1.211a10.379,10.379,0,0,0-2.074,7.574c.6,3.284,8.511,9.421,8.511,9.421l7.888-21.981s-1.062-11.042-1.155-11.432-2.4-18.257-2.4-18.257l3.075-13.711,8.562,8.785,7.213-4.926L156.2,223.476l7.408,4.536-3.351,8.743s-1.86,11.032-1.594,14.634,3.034,18.031,5.865,24.814,3.28,9.328,3.28,9.328Z",
    transform: "translate(-116.814 -97.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M303.37,56.573,199.961,67.482l-21.609,102.15,90.034,52.214,77.263-69.875Z",
    transform: "translate(-148.257 -43.637)",
    fill: "#f0c103"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M229.7,373.213l62.805,1.888-19.729-51.147-45.15,2.483Z",
    transform: "translate(-175.035 -188.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M336.711,389.527c-1.871-7.957-16.921-42.31-16.921-42.31",
    transform: "translate(-218.206 -201.58)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M172.357,330.584l-56.093,7.276s-2.779,7.912,1.839,23.347c3.627,12.12,5.131,15.577,6.061,19.282",
    transform: "translate(-73.632 -192.541)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M360.5,246.644s1.3,25.717-3.127,25.132-7.07-27.636-5.242-29.289S358.194,242.9,360.5,246.644Z",
    transform: "translate(-242.377 -144.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M315,158.055s8.143,6.65,11.382,11.761a113.935,113.935,0,0,1,12.567,28.919,23.5,23.5,0,0,0-4.873,16.563,68.853,68.853,0,0,0,1.553,9.8l-21.773-17.384,1.134-49.659Z",
    transform: "translate(-221.891 -98.785)",
    fill: "#4f83e0",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M492.3,211.931s2.115,2.35,1.318,6.8-2.033,6.137-3.034,6.1-.705-3.612-.736-5.018a24.481,24.481,0,0,0-1.073-4.6",
    transform: "translate(-316.95 -128.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M492.3,211.931s2.115,2.35,1.318,6.8-2.033,6.137-3.034,6.1-.705-3.612-.736-5.018a24.481,24.481,0,0,0-1.073-4.6",
    transform: "translate(-316.95 -128.062)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M487.054,230.938s-2.555,1.693-3.31,1.129S483.07,224,483.07,224",
    transform: "translate(-313.847 -134.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M487.054,230.938s-2.555,1.693-3.31,1.129S483.07,224,483.07,224",
    transform: "translate(-313.847 -134.621)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M474.861,229.642a3.091,3.091,0,0,1,.368,2.976c-.817,1.786-.746,3.428,1.093,2.709s1.88-2.524,2.258-4.884",
    transform: "translate(-309.316 -137.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M474.861,229.642a3.091,3.091,0,0,1,.368,2.976c-.817,1.786-.746,3.428,1.093,2.709s1.88-2.524,2.258-4.884",
    transform: "translate(-309.316 -137.687)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M335.7,312.29l3.913,2.638-3.484-32.983-2.432.893Z",
    transform: "translate(-232.677 -166.109)",
    fill: "#4f83e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M287.671,96.717l-.389,36.708-23.939-4.587L277.658,96.6Z",
    transform: "translate(-194.444 -65.391)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M317.365,49.871s2.339,25.41-7.622,29.6-18.912-13.095-20.393-20.535-.174-19.919,11.892-20.771,16.123,11.7,16.123,11.7Z",
    transform: "translate(-208.311 -33.61)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M320.951,86.417a5.5,5.5,0,0,0-3.668-2.288,5.348,5.348,0,0,0-4.148,1.416,4.462,4.462,0,0,0,4.127,2.237c2.82-.215,3.689-1.375,3.689-1.375Z",
    transform: "translate(-221.501 -58.59)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M320.721,86.351S319.188,83.3,316.4,83.1a11.875,11.875,0,0,0-5.793,1.539l.572.605s3.913-2.422,5.967-1.19,2.81,2.258,3.566,2.3Z",
    transform: "translate(-220.127 -58.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M340.592,86.82a5.5,5.5,0,0,1,3.719-2.206,5.335,5.335,0,0,1,4.117,1.509,4.49,4.49,0,0,1-4.169,2.155c-2.81-.267-3.658-1.457-3.658-1.457Z",
    transform: "translate(-236.422 -58.86)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M339.059,86.478s1.492-2.822,4.107-2.966a11.034,11.034,0,0,1,5.394,1.56l-.552.554s-3.617-2.34-5.568-1.242-2.677,2.052-3.392,2.083Z",
    transform: "translate(-235.583 -58.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M304.431,111.085s-3.648-2.709-4.853-4.608c-3.913-6.136-5.129-8.21-5.129-8.21s-.133,4.269,4.935,12.8c1.461,2.463,5.149,4.392,5.149,4.392l-.112-4.372Z",
    transform: "translate(-211.347 -66.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M143.179,224.878c-.45,2.422,2.145,2.8,2.145,2.8s-.327.76.756,1.447a2.377,2.377,0,0,0,3.28-.524c1.6-1.631,1.318-1.755,3.116-5.347,2.749-5.47,3.9-8.887,4.669-19.026s-2.361-27.308-2.555-28.673a1.886,1.886,0,0,1,.961-2.247c.664-.4,11.781-2.709,11.781-2.709a49.283,49.283,0,0,0-16.951-21.848c-12.72-9.206-3.555,5.316-3.555,5.316",
    transform: "translate(-129.115 -92.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M143.179,224.878c-.45,2.422,2.145,2.8,2.145,2.8s-.327.76.756,1.447a2.377,2.377,0,0,0,3.28-.524c1.6-1.631,1.318-1.755,3.116-5.347,2.749-5.47,3.9-8.887,4.669-19.026s-2.361-27.308-2.555-28.673a1.886,1.886,0,0,1,.961-2.247c.664-.4,11.781-2.709,11.781-2.709a49.283,49.283,0,0,0-16.951-21.848c-12.72-9.206-3.555,5.316-3.555,5.316",
    transform: "translate(-129.115 -92.068)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M141.194,157.92s-18.565,6.588-20.22,13.885,1.277,14.685,4.751,24.486a181.2,181.2,0,0,1,5.487,18.872s-3.586,3.2-2.82,7.378",
    transform: "translate(-116.821 -98.711)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M144.1,312.76s-2.084,3.49-3.8,2.9-2.176-1.241-2.472-2.155",
    transform: "translate(-126.234 -182.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M144.1,312.76s-2.084,3.49-3.8,2.9-2.176-1.241-2.472-2.155",
    transform: "translate(-126.234 -182.855)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M139.488,303.374s-2.605,4.4-5.047,1.97-.44-5.87,0-6.075,1.338-.359,1.961,2.432",
    transform: "translate(-123.748 -175.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M139.488,303.374s-2.605,4.4-5.047,1.97-.44-5.87,0-6.075,1.338-.359,1.961,2.432",
    transform: "translate(-123.748 -175.469)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M151.219,317.121l-3.3,3.715",
    transform: "translate(-131.719 -185.225)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M339.921,289.318s2.534,24.814,3.076,29.617Z",
    transform: "translate(-236.058 -170.116)",
    fill: "#4f83e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M339.921,289.318s2.534,24.814,3.076,29.617",
    transform: "translate(-236.058 -170.116)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M196.143,197.884c9.154.092,14.375-2,14.375-2Z",
    transform: "translate(-157.925 -119.341)",
    fill: "#4f83e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M196.143,197.884c9.154.092,14.375-2,14.375-2",
    transform: "translate(-157.925 -119.341)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M145.076,141.632s33.339-4.731,46.448-3.458a51.339,51.339,0,0,1,12.179,2.514",
    transform: "translate(-130.174 -87.863)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M148.438,153.66l5.426-2.555s-5.691-4.557-7.8-5.152-1.962.852-1.778,1.57,3.116,6.619,3.116,6.619Z",
    transform: "translate(-129.694 -92.132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M287.1,83.141s-4.087.267-3.75,3.674,4,2.637,5.854,2.206",
    transform: "translate(-205.304 -58.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M287.1,83.141s-4.087.267-3.75,3.674,4,2.637,5.854,2.206",
    transform: "translate(-205.304 -58.074)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M337.248,93.48a6.314,6.314,0,0,1,1.216,3.192c0,1.58-1.788,1.1-1.788,1.1",
    transform: "translate(-234.294 -63.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M337.248,93.48a6.314,6.314,0,0,1,1.216,3.192c0,1.58-1.788,1.1-1.788,1.1",
    transform: "translate(-234.294 -63.693)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M285.968,88.378l3.218,1.088",
    transform: "translate(-206.738 -60.92)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M288.5,90.828l.725-1.057",
    transform: "translate(-208.112 -61.677)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M352.6,86.52s-3.076-1.827-4.291-.575a3.332,3.332,0,0,0-.664,3.068s3.443-.6,4.955-2.483Z",
    transform: "translate(-240.189 -59.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M325.093,86.355s-1.931-2.9-4.291-1.119c-1.389,1.047-.664,3.068-.664,3.068S323.581,88.254,325.093,86.355Z",
    transform: "translate(-225.204 -58.898)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M473.923,220.221l-9.267-10.129a2.6,2.6,0,0,1,.153-3.653l19.76-14.737a2.572,2.572,0,0,1,3.637.154l9.41,7.45c.961,1.047.266,2.986-.776,3.951l-19.28,17.107a2.572,2.572,0,0,1-3.637-.154Z",
    transform: "translate(-303.474 -116.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M474.259,217.974l-9.267-10.129a2.6,2.6,0,0,1,.153-3.653l19.76-14.736a2.572,2.572,0,0,1,3.637.154l8.787,7.758a2.6,2.6,0,0,1-.153,3.654L477.9,218.127A2.572,2.572,0,0,1,474.259,217.974Z",
    transform: "translate(-303.656 -115.479)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M497.046,211.2l-8.6-8.426a2.6,2.6,0,0,1,.153-3.653l2.881-2.114a2.572,2.572,0,0,1,3.638.154l8.787,7.758a2.6,2.6,0,0,1-.153,3.654l-3.076,2.781a2.572,2.572,0,0,1-3.637-.154Z",
    transform: "translate(-316.4 -119.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M497.181,209.357l-8.6-8.426a2.6,2.6,0,0,1,.153-3.653l2.881-2.114a2.572,2.572,0,0,1,3.637.154l8.787,7.758a2.6,2.6,0,0,1-.153,3.654l-3.076,2.781a2.573,2.573,0,0,1-3.638-.154Z",
    transform: "translate(-316.474 -118.581)",
    fill: "#4f83e0",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M520.1,194.005l-.664.605a.94.94,0,0,0,0,1.375l3.116,2.7a1.14,1.14,0,0,0,1.44.082l.8-.626-4.7-4.146Z",
    transform: "translate(-333.449 -118.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M412.825,202.683a61.717,61.717,0,0,1,6.324-1.724c2.064-.339,3.832-.6,3.883.708s-7.234,7.594-10.227,9.923-6.9,1.765-8.685,2.155-12.3,8.59-15.98,11.987c-6.273,5.788-14.743,13.3-29.579,18.051,0,0-2.156-7.214-.95-12.458,2.095-9.123,4.925-10.694,4.925-10.694,32.092-10.1,35.413-19.673,47.194-22.156,2.646-.554,4.25.493,7.214,2.986",
    transform: "translate(-245.472 -120.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M412.825,202.683a61.717,61.717,0,0,1,6.324-1.724c2.064-.339,3.832-.6,3.883.708s-7.234,7.594-10.227,9.923-6.9,1.765-8.685,2.155-12.3,8.59-15.98,11.987c-6.273,5.788-14.743,13.3-29.579,18.051,0,0-2.156-7.214-.95-12.458,2.095-9.123,4.925-10.694,4.925-10.694,32.092-10.1,35.413-19.673,47.194-22.156,2.646-.554,4.25.493,7.214,2.986",
    transform: "translate(-245.472 -120.671)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M224.313,147.159s-1.625,5.1-7.387,3c-4.6-1.683-9.615-6.65-11.454-8.59a1.918,1.918,0,0,0-.521-.564c-.133-.144-.215-.236-.215-.236s-.041.01-.1.031a9.74,9.74,0,0,0-2.666-.934A91.829,91.829,0,0,0,185.058,138c-8.705-.052-24.664,1.816-24.664,1.816l-13.415,1.765,1.062.287a108.582,108.582,0,0,1,10.37,7.789c4.731,4.115,9.288,12.838,9.288,12.838l1.727,3.941s4.72-.144,8.051-.513c2.421-.267,6.631-1.057,8.756-1.477a84.941,84.941,0,0,0-2.575,9.533c-6.232,29.535-9.819,59.244-9.819,59.244s25-1.8,46.55-.841c7.949.349,14.682.862,17.758,4.331,0,0-1.257-23.264-1.88-30.417,0,0-.726-23.326-4.9-32.593",
    transform: "translate(-131.208 -87.888)",
    fill: "#4f83e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M224.313,147.159s-1.625,5.1-7.387,3c-4.6-1.683-9.615-6.65-11.454-8.59a1.918,1.918,0,0,0-.521-.564c-.133-.144-.215-.236-.215-.236s-.041.01-.1.031a9.74,9.74,0,0,0-2.666-.934A91.829,91.829,0,0,0,185.058,138c-8.705-.052-24.664,1.816-24.664,1.816l-13.415,1.765,1.062.287a108.582,108.582,0,0,1,10.37,7.789c4.731,4.115,9.288,12.838,9.288,12.838l1.727,3.941s4.72-.144,8.051-.513c2.421-.267,6.631-1.057,8.756-1.477a84.941,84.941,0,0,0-2.575,9.533c-6.232,29.535-9.819,59.244-9.819,59.244s25-1.8,46.55-.841c7.949.349,14.682.862,17.758,4.331,0,0-1.257-23.264-1.88-30.417,0,0-.726-23.326-4.9-32.593",
    transform: "translate(-131.208 -87.888)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M335.6,347.869l2.575,7.307s3.086-2.607,2.82-3.7C340.854,350.886,340.271,348.69,335.6,347.869Z",
    transform: "translate(-233.71 -201.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M297.385,37.829c-7.469,0-10.708,5.8-14.743,9.564s-10.82,1.591-10.82,1.591,1.441,7.82,11.249,6.229,15.02-11.155,15.02-11.155,4.873,9.564,9.277,9.708,3.515-3.766,3.1-5.213-.429-7.533-8.215-11.3-10.238-4.639-15.571-3.479-4.3,6.086-9.5,7.389a26.952,26.952,0,0,1-8.215,1.016s2.432,6.3,7.081,6.989a8.819,8.819,0,0,0,7.571-2.73L286,43.873",
    transform: "translate(-197.496 -30.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M297.385,37.829c-7.469,0-10.708,5.8-14.743,9.564s-10.82,1.591-10.82,1.591,1.441,7.82,11.249,6.229,15.02-11.155,15.02-11.155,4.873,9.564,9.277,9.708,3.515-3.766,3.1-5.213-.429-7.533-8.215-11.3-10.238-4.639-15.571-3.479-4.3,6.086-9.5,7.389a26.952,26.952,0,0,1-8.215,1.016s2.432,6.3,7.081,6.989a8.819,8.819,0,0,0,7.571-2.73L286,43.873",
    transform: "translate(-197.496 -30.988)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M152.464,379.4s12.162,16.744,12.162,27.868",
    transform: "translate(-86.067 -219.07)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M319.311,107.325s1.226,4.054,4.475,2.535",
    transform: "translate(-224.857 -71.217)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M486.78,129.436l-23.643-3.92a5.1,5.1,0,0,0-5.865,4.218l-2.881,17.507a5.12,5.12,0,0,0,4.2,5.891l11.821,1.96,5.374,6.362,6.447-4.4a5.1,5.1,0,0,0,5.865-4.218l2.881-17.507A5.12,5.12,0,0,0,486.78,129.436Z",
    transform: "translate(-298.226 -81.064)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M383.6,115.38l17.073-6.219a3.86,3.86,0,0,1,4.955,2.329l4.567,12.643a3.887,3.887,0,0,1-2.319,4.977l-8.532,3.11-3.116,5.49-5.415-2.381A3.86,3.86,0,0,1,385.858,133l-4.567-12.643a3.887,3.887,0,0,1,2.319-4.977Z",
    transform: "translate(-258.413 -72.088)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M474.346,65.257,462.371,60.9a2.706,2.706,0,0,0-3.474,1.632l-3.208,8.867a2.724,2.724,0,0,0,1.625,3.489l5.987,2.186,2.187,3.848,3.8-1.673a2.706,2.706,0,0,0,3.474-1.632l3.208-8.867A2.724,2.724,0,0,0,474.346,65.257Z",
    transform: "translate(-298.88 -45.897)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M499.659,146.454a3.373,3.373,0,0,0-4.7,1.4l-.245.523a.351.351,0,0,0,.153.462.338.338,0,0,0,.47-.164l.174-.369a2.693,2.693,0,0,1,3.668-1.149,2.775,2.775,0,0,1,1.083,3.694l-1.287,2.514.623.318,1.349-2.638a3.466,3.466,0,0,0-1.278-4.587Z",
    transform: "translate(-320.157 -92.233)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M492.222,158.756l-6.508-3.356a1.019,1.019,0,0,0-1.376.444l-2.24,4.382a1.028,1.028,0,0,0,.442,1.382l6.508,3.356a1.019,1.019,0,0,0,1.376-.444l2.24-4.382A1.028,1.028,0,0,0,492.222,158.756Z",
    transform: "translate(-313.259 -97.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M494.157,158.265l-6.508-3.356a1.02,1.02,0,0,0-1.376.444l-2.24,4.382a1.029,1.029,0,0,0,.442,1.382l6.508,3.356a1.02,1.02,0,0,0,1.376-.444l2.24-4.382A1.029,1.029,0,0,0,494.157,158.265Z",
    transform: "translate(-314.31 -97.013)",
    fill: "#4f83e0",
    stroke: "#4f83e0",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M495.372,164.432a.88.88,0,1,0-1.482.123l-.347.678a.379.379,0,1,0,.674.349l.347-.678A.9.9,0,0,0,495.372,164.432Z",
    transform: "translate(-319.518 -101.549)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M492.318,148.031l-.674-2.473",
    transform: "translate(-318.507 -91.993)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M487.643,152.463,485,151.806",
    transform: "translate(-314.895 -95.389)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M488.7,149.211l-2.207-2.237",
    transform: "translate(-315.71 -92.763)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M402.858,129.534l3.188.708a.306.306,0,0,1,.235.195l2.513,6.373a.331.331,0,0,1-.082.329l-2.452,2.5a.315.315,0,0,1-.521-.113l-3.249-9.6a.323.323,0,0,1,.378-.41Z",
    transform: "translate(-270.05 -83.276)",
    fill: "#4f83e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M415.21,128.734l-3.394,1.194a.288.288,0,0,0-.176.366l2.074,5.947a.285.285,0,0,0,.364.176l3.394-1.194a.288.288,0,0,0,.176-.366l-2.074-5.947A.286.286,0,0,0,415.21,128.734Z",
    transform: "translate(-275.022 -82.842)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M404.454,130.143l2.861.606a.3.3,0,0,1,.215.184l2.145,6.167a.29.29,0,0,1-.072.3l-1.972,1.93a.289.289,0,0,1-.47-.113l-3.034-8.7a.29.29,0,0,1,.327-.38Z",
    transform: "translate(-270.94 -83.608)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M399.423,134.23l-3.065,1.344",
    transform: "translate(-266.727 -85.838)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M401.5,137.309l-2.207,1",
    transform: "translate(-268.32 -87.511)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M400.649,140.388,396.828,142",
    transform: "translate(-266.982 -89.184)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M340.592,77.906a9.046,9.046,0,0,1,8.245,0",
    transform: "translate(-236.422 -54.687)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M310.919,76.8a9.046,9.046,0,0,1,8.245,0",
    transform: "translate(-220.297 -54.088)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M474.995,74.549l-2.7-1.079L470.264,78.6l2.7,1.079Z",
    transform: "translate(-306.889 -52.819)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M480.889,76.916l-2.7-1.079-2.035,5.129,2.7,1.079Z",
    transform: "translate(-310.092 -54.105)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M481.4,72.2l-2.7-1.079-.3.744,2.7,1.079Z",
    transform: "translate(-311.316 -51.543)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M486.1,83.167l-.45-.185.378-.3.388-.308.072.482.072.493Z",
    transform: "translate(-315.248 -57.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M485.984,84.157l.46.185-.389.3-.378.308-.071-.482-.072-.493Z",
    transform: "translate(-315.187 -58.526)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.392a8c20.svg";
export { ForwardRef as ReactComponent };